import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Avatar, AvatarFallback } from './ui/avatar';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Александр Петров',
      position: 'CEO, TechStore',
      avatar: 'АП',
      rating: 5,
      text: 'Внедрили AI чат-бот для продаж. Бот обрабатывает 85% запросов сам, конверсия выросла на 45%. Теперь не думаем о найме новых менеджеров!'
    },
    {
      name: 'Мария Соколова',
      position: 'Основатель, BeautyLine',
      avatar: 'МС',
      rating: 5,
      text: 'Бот запоминает каждого клиента и делает персональные предложения. Умные рассылки на основе поведения увеличили повторные покупки на 60%!'
    },
    {
      name: 'Дмитрий Волков',
      position: 'Владелец, FitLife',
      avatar: 'ДВ',
      rating: 5,
      text: 'Раньше нужен был целый отдел продаж. Теперь один бот работает 24/7, продает и консультирует лучше людей. Окупился за месяц!'
    },
    {
      name: 'Елена Краснова',
      position: 'Директор, EduPro',
      avatar: 'ЕК',
      rating: 5,
      text: 'Автоматизировали продажу курсов. Бот отвечает на вопросы, обрабатывает возражения и записывает на обучение. Освободили 30 часов в неделю!'
    },
    {
      name: 'Игорь Морозов',
      position: 'Владелец, AutoService',
      avatar: 'ИМ',
      rating: 5,
      text: 'Интеграция с CRM работает безупречно. Все лиды автоматом попадают в систему, бот запускает умные рассылки. Продажи выросли на 70%!'
    },
    {
      name: 'Анна Белова',
      position: 'CMO, RestoBiz',
      avatar: 'АБ',
      rating: 5,
      text: 'Бот принимает заказы, бронирует столики и отправляет акции нужным клиентам. Больше не нужны операторы — всё автоматизировано!'
    }
  ];

  return (
    <section id="testimonials" className="py-16 sm:py-24 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Отзывы наших клиентов
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
            Более 100 компаний уже автоматизировали свой бизнес с нами
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {testimonials.map((testimonial, index) => (
            <Card key={index} className="group hover:shadow-2xl transition-all duration-300 border-2 hover:border-blue-200 bg-white">
              <CardContent className="p-6">
                <Quote className="w-10 h-10 text-blue-200 mb-4" />
                
                <div className="flex mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 fill-[#FFD700] text-[#FFD700]" />
                  ))}
                </div>

                <p className="text-gray-700 mb-6 leading-relaxed italic">
                  "{testimonial.text}"
                </p>

                <div className="flex items-center">
                  <Avatar className="h-12 w-12 bg-blue-600 text-white">
                    <AvatarFallback className="bg-blue-600 text-white font-semibold">
                      {testimonial.avatar}
                    </AvatarFallback>
                  </Avatar>
                  <div className="ml-4">
                    <div className="font-bold text-gray-900">{testimonial.name}</div>
                    <div className="text-sm text-gray-600">{testimonial.position}</div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
